// extracted by mini-css-extract-plugin
export default {"add-delete-button":"checklist-row_add-delete-button__i6hTE","subhead-row":"checklist-row_subhead-row__Pvifu"};